module.exports = __webpack_public_path__ + "static/media/clipboard-list-solid.91517151.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/clipboard-list-solid.svg
// module id = 667
// module chunks = 2